<template>
  <v-row class="table-controls items-center">
    <v-col sm="12" md="6" lg="6" cols="12">
      <div class="d-flex" v-if="exportAvailable">
        <v-btn
          color='transparent'
          depressed
          class='px-2'
          @click="exportPDF"
        >
          <v-img max-height="20" max-width="20" class="mr-2" src="@/assets/icons/svg/export.svg"/>
          <span class="text-subtitle-2 font-weight-bold">Download PDF</span>
        </v-btn>
      </div>
    </v-col>
    <v-col sm="12" md="6" lg="6" cols="12">
      <v-row class="items-center">
        <v-col sm="12" md="6" lg="6" cols="12">
          <div class="d-flex justify-end">
            <FilterByPeriod @on-change="filterByPeriod" />
          </div>
        </v-col>
        <v-col sm="12" md="6" lg="6" cols="12">
          <div class="d-flex justify-end">
            <FilterByFolder @on-change="filterByFolder" />
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment'
import FilterByFolder from './FilterByFolder'
import FilterByPeriod from './FilterByPeriod'

export default {
  name: 'ControlPanel',
  components: { FilterByFolder, FilterByPeriod },
  props: ['filter', 'exportAvailable'],
  data() {
    return {
    }
  },
  methods: {
    filterByFolder(folderId) {
      this.filter.categoryId = folderId
      this.$emit('on-change')
    },
    filterByPeriod(date) {
      this.filter.date = date ? moment(date).utc(true).format() : null
      this.$emit('on-change')
    },
    exportPDF() {
      this.$emit('on-export', this.exportType)
    }
  },
  created() {
  }
}
</script>

<style scoped lang="scss">

</style>
